import { EpochMillis, epochMillis, KeycloakCredentialContainer } from "core/types"

const PASSWORD_CREDENTIAL_TYPE = "password"

/**
 * When the password was last set. Keycloak has no "updated" timestamp; setting
 * a new password replaces the credential, so its `createdDate` is the date the
 * password last changed. Reported in milliseconds, unlike session timestamps.
 */
export const passwordUpdatedAt = (
  containers: KeycloakCredentialContainer[]
): EpochMillis | null => {
  const password = containers.find(
    (container) => container.type === PASSWORD_CREDENTIAL_TYPE
  )

  const createdDate =
    password?.userCredentialMetadatas?.[0]?.credential?.createdDate

  return typeof createdDate === "number" ? epochMillis(createdDate) : null
}
